import { Controller } from '@hotwired/stimulus'

// Subscribers-Table mit clientseitigem Filter (Suche per Name/Email) + sortierbaren Spalten.
// Erwartetes Markup: tbody>tr mit data-search + data-<column>-Attributen.
export default class extends Controller {
  static targets = ['searchInput', 'table', 'row']

  connect() {
    this.currentSort = { key: null, dir: 'asc' }
  }

  filter() {
    const q = this.searchInputTarget.value.toLowerCase().trim()
    this.rowTargets.forEach(row => {
      const haystack = (row.dataset.search || '').toLowerCase()
      row.style.display = (q === '' || haystack.includes(q)) ? '' : 'none'
    })
  }

  sort(event) {
    const th = event.currentTarget
    const key = th.dataset.sortBy
    if (!key) return

    if (this.currentSort.key === key) {
      this.currentSort.dir = this.currentSort.dir === 'asc' ? 'desc' : 'asc'
    } else {
      this.currentSort = { key, dir: 'asc' }
    }

    const tbody = this.tableTarget.querySelector('tbody')
    const rows = Array.from(this.rowTargets)
    rows.sort((a, b) => {
      const av = a.dataset[key] ?? ''
      const bv = b.dataset[key] ?? ''
      const cmp = isFinite(+av) && isFinite(+bv)
        ? (+av) - (+bv)
        : av.localeCompare(bv, 'de')
      return this.currentSort.dir === 'asc' ? cmp : -cmp
    })
    rows.forEach(r => tbody.appendChild(r))
    this.updateSortIcons(key)
  }

  updateSortIcons(activeKey) {
    this.tableTarget.querySelectorAll('th[data-sort-by]').forEach(th => {
      const icon = th.querySelector('i.fa')
      if (!icon) return
      icon.classList.remove('fa-sort', 'fa-sort-up', 'fa-sort-down')
      if (th.dataset.sortBy === activeKey) {
        icon.classList.add(this.currentSort.dir === 'asc' ? 'fa-sort-up' : 'fa-sort-down')
        icon.classList.remove('text-muted')
      } else {
        icon.classList.add('fa-sort', 'text-muted')
      }
    })
  }
}
